export default {
  name: 'pc-space',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '空白间距',
          icon: 'el-icon-d-caret',
          type: '辅助类',
          content: {
            height: 16,
            isShow: true
          },
          config: [{
            label: '隐藏占位文字',
            name: 'isShow',
            type: 'switch',
            value: true
          }, {
            label: '间距',
            name: 'height',
            type: 'number',
            value: '0'
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};